// extracted by mini-css-extract-plugin
module.exports = {"additionalContent":"candidateDashboardPage_additionalContent__3pfeM","select":"candidateDashboardPage_select___6cCj","noData":"candidateDashboardPage_noData__14JPR"};